// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ir0dO","chartContainer":"styles_chartContainer__3cx8p","heading":"styles_heading__Bk_R8","btnWrapper":"styles_btnWrapper__2Bn50"};